<i *ngFor="let e of estrelas()" class="fa fa-star"></i>
<i *ngIf="estrela % 1 > 0" class="fa fa-star-half"></i>
